export enum ApplicabilityEnum {
    Applicable = 0,
    NonApplicable = 1,
    PotentiallyApplicable = 2
}
